import React, { FC } from "react";
import { View, Text, StyleSheet, StyleProp, TextStyle } from "react-native";
import StyledIcon, { LibNames } from "../../components/StyledIcon";
import Colors from "../../constants/Colors";

const IconText: FC<{
  icon: string;
  text: string;
  color: string;
  size?: number;
  textStyle?: StyleProp<TextStyle>;
  iconLibrary?: LibNames;
}> = ({ icon, text, color, size, textStyle, iconLibrary }) => {
  const defaultSize = 14;
  return (
    <View style={styles.iconTextContainer}>
      <View style={styles.iconWrapper}>
        <StyledIcon
          iconName={icon}
          iconColor={color}
          size={size || defaultSize}
          iconOnly
          iconLibrary={iconLibrary || "MaterialCommunityIcons"}
        />
      </View>
      <Text
        style={[
          styles.iconTextContent,
          { fontSize: size || defaultSize },
          { color: color || Colors.tintColor },
          textStyle,
        ]}
      >
        {text}
      </Text>
    </View>
  );
};

export default IconText;

const styles = StyleSheet.create({
  iconTextContainer: {
    flexDirection: "row",
    alignItems: "center",
    alignContent: "center",
    justifyContent: "center",
  },
  iconWrapper: {
    justifyContent: 'center',
  },
  iconTextContent: {
    paddingLeft: 4,
    alignSelf: "center",
  },
});
